var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndtoEndShipmentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 573,
    height: 309,
    viewBox: "0 0 573 309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.399,
    x2: 0.5,
    y2: 0.631,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e00dd"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.369,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(-200 -2555)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 573,
    height: 309,
    rx: 20,
    transform: "translate(200 2555)",
    opacity: 0.85,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 200, 2555)",
    filter: "url(#Rectangle_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-3",
    "data-name": "Rectangle 8",
    width: 573,
    height: 309,
    rx: 20,
    fill: "#fff",
    opacity: 0.85
  }))), /*#__PURE__*/React.createElement("text", {
    id: "End-to-end_Shipment_Management",
    "data-name": "End-to-end Shipment Management",
    transform: "translate(263 2643)",
    fill: "#fff",
    fontSize: 70,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "End-to-end"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 83
  }, "Shipment"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 166
  }, "Management")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndtoEndShipmentManagement);
export default __webpack_public_path__ + "static/media/End to End Shipment Management.042a70217dab9e2a1d35aeb3e177f968.svg";
export { ForwardRef as ReactComponent };